import styled, { css } from 'styled-components'

type AuthInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean
  endContent?: React.ReactNode
}

export const AuthInput: React.FC<AuthInputProps> = ({
  error = false,
  endContent,
  className,
  ...inputProps
}) => {
  return (
    <Root $error={error} className={className}>
      <Input
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck="false"
        autoComplete="off"
        {...inputProps}
      />
      {endContent}
    </Root>
  )
}

export const AuthErrorHint = styled.div`
  color: var(--error-10);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-top: 8px;
`

const Root = styled.div<{ $error: boolean }>`
  height: 64px;
  width: 100%;

  border-radius: 12px;
  border: 1.6px solid var(--backgroundA-10);
  background: var(--backgroundA-3);

  ${({ $error }) => {
    if ($error) {
      return css`
        border-color: var(--error-10);
        background: rgba(var(--error-9-rgb), 0.1);
      `
    }
  }}

  display: grid;
  justify-items: start;
  align-items: center;
  grid-template-columns: minmax(0, 1fr) auto;

  padding-inline: 16px;
`

const Input = styled.input`
  width: 100%;
  height: 100%;
  padding: 0;
  outline: none;
  border: none;
  background: transparent;
  color: var(--text-12);
  font-size: 22px;
  font-weight: 600;
  line-height: 24px;
`
